import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Modules
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzQRCodeModule } from 'ng-zorro-antd/qr-code';
import { NzCardModule } from 'ng-zorro-antd/card';

const MODULES: Array<object> = [
	NzLayoutModule,
	NzMenuModule,
	NzIconModule,
	NzImageModule,
	NzSpaceModule,
	NzFormModule,
	NzInputModule,
	NzButtonModule,
	NzMessageModule,
	NzGridModule,
	NzTypographyModule,
	NzTableModule,
	NzDropDownModule,
	NzToolTipModule,
	NzCheckboxModule,
	NzAlertModule,
	NzBadgeModule,
	NzModalModule,
	NzSelectModule,
	NzRadioModule,
	NzSpinModule,
	NzPopoverModule,
	NzDatePickerModule,
	NzPopconfirmModule,
	NzListModule,
	NzEmptyModule,
	NzUploadModule,
	NzSwitchModule,
	NzTabsModule,
	NzSliderModule,
	NzTagModule,
	NzDividerModule,
	NzTreeModule,
	NzCollapseModule,
	NzStepsModule,
	NzFlexModule,
	NzQRCodeModule,
	NzCardModule
];

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MODULES
	],
	exports: [
		MODULES
	]
})
export class AntdModule { }
